'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherArrowRight, FeatherClock, FeatherShield } from '@subframe/core';
import { Badge, Button } from '@/shared/components/ui';
import type { UseNegociacaoSelfReturn } from '../hooks';
interface LandingScreenProps {
  vm: UseNegociacaoSelfReturn;
}
const destaques = [{
  icon: <FeatherClock className="text-brand-600" />,
  titulo: 'Configure em minutos',
  descricao: 'Em poucos passos sua Lexi está pronta'
}, {
  icon: <FeatherShield className="text-brand-600" />,
  titulo: 'Seus dados protegidos',
  descricao: 'Privacidade garantida em todas as etapas'
}];
export const LandingScreen = t0 => {
  const $ = _c(12);
  const {
    vm
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Badge variant="brand" className="self-start">Novo agente</Badge>;
    t2 = <h1 className="text-heading-dark text-3xl leading-tight font-semibold tracking-tight sm:text-4xl lg:text-[40px]">Vamos criar sua Lexi, seu agente de negociação</h1>;
    t3 = <p className="text-base leading-relaxed text-neutral-700">Você diz como quer negociar e a Lexi faz o resto.</p>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FeatherArrowRight />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== vm) {
    t5 = <div className="flex max-w-[560px] flex-1 flex-col justify-center gap-6">{t1}{t2}{t3}<Button size="medium" className="mt-2 self-start" iconRight={t4} onClick={() => vm.goTo("objetivo")}>Criar minha Lexi</Button></div>;
    $[4] = vm;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mt-auto flex flex-wrap gap-8 border-t border-solid border-neutral-100 pt-6">{destaques.map(_temp)}</div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <div className="flex flex-1 flex-col justify-center gap-10 px-6 py-12 sm:gap-12 sm:px-8 sm:py-16 lg:px-[5vw]">{t5}{t6}</div>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="relative hidden overflow-hidden bg-[url('/images/07%201.png')] bg-cover bg-center bg-no-repeat lg:block lg:min-h-screen lg:w-1/2" />;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7) {
    t9 = <div className="flex min-h-screen w-full flex-col overflow-hidden bg-white lg:flex-row">{t7}{t8}</div>;
    $[10] = t7;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
};
function _temp(destaque) {
  return <div key={destaque.titulo} className="flex max-w-[260px] items-center gap-3"><div className="bg-brand-50 flex h-10 w-10 flex-none items-center justify-center rounded-[12px]">{destaque.icon}</div><div><div className="text-heading-dark text-sm font-semibold">{destaque.titulo}</div><div className="text-xs text-neutral-500">{destaque.descricao}</div></div></div>;
}